// frontend/src/components/user/UserAvatar.jsx
import React from 'react';
// Import the CSS module for UserAvatar
import './UserAvatar.css'; // Make sure this line is uncommented and points to your CSS module

const UserAvatar = ({ user, src, alt, size = 'medium', className = '' }) => {
  const getInitials = (name) => name ? name.charAt(0).toUpperCase() : '?';
  
  // Determine the image size based on the 'size' prop (can be 'small', 'medium', 'large', 'xlarge', or a number)
  let imageSizeValue;
  if (typeof size === 'number') {
    imageSizeValue = size;
  } else {
    switch (size) {
      case 'small': imageSizeValue = 32; break;
      case 'medium': imageSizeValue = 40; break;
      case 'large': imageSizeValue = 80; break;
      case 'xlarge': imageSizeValue = 130; break; // Added for the large profile avatar
      default: imageSizeValue = 40; // Default to medium
    }
  }

  // FIXED: Handle both snake_case (from API) and camelCase (legacy)
  const finalSrc = user?.avatar_url || user?.avatarUrl || src;
  const finalAlt = user?.display_name || user?.displayName || alt || 'User Avatar';
  const initials = getInitials(user?.display_name || user?.displayName || finalAlt);

  // FIX: Change placeholderUrl to a local asset path
  // Make sure you have a default_avatar.png or similar file in your public/assets folder
  const placeholderUrl = '/assets/default_avatar.png'; // Example: Path to a local default avatar

  return (
    <img 
      src={finalSrc || placeholderUrl} // Use finalSrc, fallback to placeholderUrl
      alt={finalAlt}
      // Use template literals for className for better readability and consistency with CSS Modules
      className={`user-avatar avatar-size-${typeof size === 'number' ? 'custom' : size} ${className}`}
      // Inline styles for dynamic sizing and circular shape
      style={{ width: imageSizeValue, height: imageSizeValue, borderRadius: '50%', objectFit: 'cover', backgroundColor: '#ccc' }}
      // On error, fall back to the local placeholder image
      onError={(e) => {
        // Prevent infinite loops if the placeholder itself fails or is blocked
        if (e.target.src !== placeholderUrl) {
          e.target.src = placeholderUrl;
        }
      }}
    />
  );
};

export default UserAvatar;
